import {
  ValidateBulkBudgetAssignmentResponse,
  QueryValidateBulkBudgetAssignmentArgs,
  CreateBulkBudgetAssignmentResponse,
  MutationCreateBulkBudgetAssignmentArgs
} from "@irati/types"
import {createUseLazyQuery, createUseMutation} from "@irati/utils/services/apollo"
import {gql} from "@irati/utils/gql"

export const useBulkBudgetAssignment = createUseLazyQuery<ValidateBulkBudgetAssignmentResponse, QueryValidateBulkBudgetAssignmentArgs>(
  gql`
    query ValidateBulkBudgetAssignment($input: ValidateBulkBudgetAssignmentInput!) {
      validateBulkBudgetAssignment(input: $input) {
        valid
        errors {
          userId
          errorType
          budget
        }
      }
    }
  `,
  {
    key: "validateBulkBudgetAssignment"
  }
)

export const useBulkBudgetAssignmentMutation = createUseMutation<
  CreateBulkBudgetAssignmentResponse,
  MutationCreateBulkBudgetAssignmentArgs
>(
  gql`
    mutation CreateBulkBudgetAssignment($input: CreateBulkBudgetAssignmentInput!) {
      createBulkBudgetAssignment(input: $input) {
        success
      }
    }
  `,
  {
    key: "createBulkBudgetAssignment"
  }
)
